import React from 'react';

export default function FilterChip({ active, children, onClick, ...rest }) {
  return (
    <button
      onClick={onClick}
      {...rest}
      className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-[11px] transition-colors border ${
        active
          ? 'bg-[#B0FC38]/15 border-[#B0FC38]/30 text-white'
          : 'bg-white/[0.02] border-white/[0.08] text-gray-400 hover:text-white hover:border-white/[0.15]'
      }`}
    >
      {children}
    </button>
  );
}
